var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip.left-start",value:(_vm.payload.title),expression:"payload.title",modifiers:{"left-start":true}}],staticClass:"sidebar-block",class:{
    'sidebar-block--active': _vm.hash === _vm.$route.params.unit,
    'sidebar-block--open': _vm.payload.open,
    'sidebar-block--closed': !_vm.payload.open
  },attrs:{"to":{ name: 'stack', params: { unit: _vm.hash } }}})}
var staticRenderFns = []

export { render, staticRenderFns }